module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPjxwYXRoIGZpbGw9IiNmNDQzMzYiIGQ9Ik00NCwyNGMwLDExLjA0NS04Ljk1NSwyMC0yMCwyMFM0LDM1LjA0NSw0LDI0UzEyLjk1NSw0LDI0LDRTNDQsMTIuOTU1LDQ0LDI0eiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yOS42NTYsMTUuNTE2bDIuODI4LDIuODI4bC0xNC4xNCwxNC4xNGwtMi44MjgtMi44MjhMMjkuNjU2LDE1LjUxNnoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzIuNDg0LDI5LjY1NmwtMi44MjgsMi44MjhsLTE0LjE0LTE0LjE0bDIuODI4LTIuODI4TDMyLjQ4NCwyOS42NTZ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./resources/images/icon-cancel.svg
// module id = 569
// module chunks = 0